<pr-form
  (onSubmit)="onSubmit()"
  title="VOTRE PORTFEUILLE SUR MESURE "
  [formGroup]="form"
>
  <pr-color-panel [display]="allocationPanel.display">
    <pr-panel-body clazz="pam">
      <pr-label [name]="allocationPanel.icon" [width]="18" [height]="18">{{
        allocationPanel.text
      }}</pr-label>
    </pr-panel-body>
  </pr-color-panel>

  <!-- <pr-input-radio formControlName="repartitionType" label="Répartition par"
    [options]="[{value : 'PERCENT', label : 'Pourcentage'},{value : 'SHARE', label : 'Part(s)'}]">
  </pr-input-radio> -->

  <div class="mbl text-center">
    <span>Répartition par : </span>
    <pr-radio
      [choices]="[
        ['PERCENT', 'Pourcentage'],
        ['PARTS', 'Part(s)'],
      ]"
      (onSelectChoice)="toggleColumnType($event)"
    >
    </pr-radio>
  </div>

  <pr-table-form
    #tableForm
    [formGroup]="form.get('scpis')"
    [addButtonLabel]="'Ajouter une nouvelle SCPI'"
    swiperMinWidth="768"
    [columnsDefinition]="currentColumnDefinition"
    [addListOptions]="scpiList"
    [formatTable]="formatTableDataFunction()"
    (optionSelected)="newOptionLogic()"
    [createModelDefinition]="createModel.bind(this)"
  >
  </pr-table-form>
</pr-form>
